import { render, staticRenderFns } from "./ModalBalanceBlocked.vue?vue&type=template&id=12ea5267&scoped=true"
import script from "./ModalBalanceBlocked.vue?vue&type=script&lang=js"
export * from "./ModalBalanceBlocked.vue?vue&type=script&lang=js"
import style0 from "./ModalBalanceBlocked.vue?vue&type=style&index=0&id=12ea5267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ea5267",
  null
  
)

export default component.exports